import React, { useState, useEffect, useRef } from "react";
import { classNames } from "primereact/utils";
import { DataTable} from "primereact/datatable";
import { Column } from "primereact/column";
import { Form, Field } from "react-final-form";
import { Toast } from "primereact/toast";
import { Button } from "primereact/button";
import { Dialog } from "primereact/dialog";
import { InputText } from "primereact/inputtext";
import { Dropdown } from 'primereact/dropdown';
import { ProgressSpinner } from "primereact/progressspinner";
import { instance } from "../../api";
import { useSecteur } from "../../Context/SecteurContext";
import { useFonction } from "../../Context/FonctionContext";
import { useUser } from "../../Context/UserContext";
import moment from "moment";
import { DeleteUserByContact, getUserByClient } from "../../Data/user_service";
import { useQuery } from "react-query";
import fetchSecteur from "../../Data/secteur_service";
import fetchFonction from "../../Data/fonction_service";
import "./utilisateur.css"
import bcrypt from 'bcryptjs';
import "./Pagination.css";
import Pagination from "./Pagination";

export default function Utilisateurs() {
  const [editUserDialog, setEditUserDialog] = useState(false);
  const [errors, setErrors] = useState({});
  // const [deleteUserDialog, setDeleteUserDialog] = useState(false);
  const [GexUsers, setGexUsers] = useState();
  const [GexUser, setGexUser] = useState();
  const [addUserDialog, setAddUserDialog] = useState(false);
  const [users, setUsers] = useState([]);
  const [clients, setClients] = useState([]);
  const [user, setUser] = useState([]);
  const [searchText, setSearchText] = useState(""); // Stocker le texte de recherche
  const [filteredUsers, setFilteredUsers] = useState([]); // Stocker les utilisateurs filtrés
  const [globalFilter, setGlobalFilter] = useState(null);
  const [selectedUser, setSelectedUser] = useState(null);
  const [deleteDialog, setDeleteDialog] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768); // Mobile state
  const toast = useRef(null);
  const dt = useRef(null);
  const {secteurs , setSecteurAttributes} = useSecteur()
  const {fonctions , setFonctionAttributes } = useFonction()
  const [currentPage, setCurrentPage] = useState(1);
  //const dataPerPage = 10;
  const [dataPerPage, setDataPerPage] = useState(100);
  
  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };
  

  
  const totalPages = Math.ceil((filteredUsers?.length || 0) / dataPerPage);
  const lastIndex = currentPage * dataPerPage;
  const firstIndex = lastIndex - dataPerPage;
  const currentData = filteredUsers?.slice(firstIndex, lastIndex) || [];
  const [isUpdating, setIsUpdating] = useState(false);

  
  const fetchUserById = (id) => {
    return instance.get(`/api/utilisateurs/${id}`).then((response) => response.data);
  };
  
  
  useQuery('secteur', ()=>fetchSecteur(setSecteurAttributes))
  useQuery('fonction', ()=>fetchFonction(setFonctionAttributes))
  const getAllUser = () => {
    instance
      .get(`/api/utilisateurs/`)
      .then((result) => {
        const sortedUsers = result.data.sort((a, b) => {
          const nameComparison = a.nom.toLowerCase().localeCompare(b.nom.toLowerCase());
          return nameComparison !== 0
            ? nameComparison
            : a.prenom.toLowerCase().localeCompare(b.prenom.toLowerCase());
        });
  
        setGexUsers(sortedUsers);
        setFilteredUsers(sortedUsers); // Ensures filteredUsers matches the latest data
      })
      .catch((error) => console.error("Erreur lors du chargement des utilisateurs :", error));
  };

  const { refetch } = useQuery('UtilisateursList', getAllUser, { refetchOnWindowFocus: false });
  
  const [roles, setRoles] = useState([
    { label: "Utilisateur", value: "utilisateur" },
    { label: "GexMember", value: "GexMember" },
    { label: "Invité", value: "Invité" },
  ]); // Available roles
  const [selectedRole, setSelectedRole] = useState(""); 
  
  
 
  

  
  
  useEffect(() => {
    getAllUser();
  }, [])
  useEffect(() => {
    instance.get("/api/clients/")
      .then(response => {
        console.log("Fetched Clients:", response.data); // Debugging
        setClients(response.data); // Ensure it's an array of clients
      })
      .catch(error => console.error("Erreur lors du chargement des clients :", error));
  }, []);
  const handleAddUser = (e) => {
    e.preventDefault();
    let newErrors = {};

    // Basic validation checks
    if (!user.nom) newErrors.nom = "Nom requis";
    if (!user.prenom) newErrors.prenom = "Prénom requis.";
    if (!user.email) {
        newErrors.email = "Adresse mail requise.";
    } else {
        // Optional: Email format validation
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (!emailRegex.test(user.email)) {
            newErrors.email = "Format de l'adresse mail incorrect.";
        }
    }
    if (!user.rattache?.id_client_gexpertise) newErrors.rattache = "Client requis.";
    if (!selectedRole) newErrors.role = "Rôle requis.";


    setErrors(newErrors);
    if (Object.keys(newErrors).length > 0) return; 
   
    const existingUser = GexUsers.find(
        (u) =>
            u.role === selectedRole &&
            u.rattache?.id_client_gexpertise === user.rattache?.id_client_gexpertise
    );

    if (existingUser) {
        toast.current.show({
            severity: "error",
            summary: "Erreur",
            detail: "Un utilisateur avec le même rôle et la même société existe déjà.",
            life: 3000,
        });
        return;
    }


    const payload = {
        nom: user.nom,
        prenom: user.prenom,
        email: user.email ,
        //id_client_gexpertise: user.rattache.id_client_gexpertise,
        role: selectedRole, 
        
    };
     // API call with dynamic clientId
     const clientId = user.rattache.id_client_gexpertise;

    instance.post(`/api/utilisateurs/add/utilisateur/${clientId}`, payload)
        .then(response => {
            setAddUserDialog(false);
            toast.current.show({
                severity: "success",
                summary: "Utilisateur ajouté",
                detail: "Ajout réussi",
                life: 2000,
            });
            refetch(); 
            // Assuming response.data contains the newly added user
            const newUser = response.data;
            // Update GexUsers and filteredUsers
            setGexUsers(prevUsers => [...prevUsers, newUser]); 
            setFilteredUsers(prevUsers => [...prevUsers, newUser]); // Ensure UI reflects new user
            refetch();

      
        })
        .catch((error) => {
          console.error("Erreur lors de l'ajout :", error);
          toast.current.show({
              severity: "error",
              summary: "Erreur",
              detail: "Erreur lors de l'ajout",
              life: 3000,
          });
      });
};


const handleArchiveUser = (user) => {
  setIsUpdating(true);
  const updatedArchiveState = !user.archive; 


  // Optimistic update: Update the local state immediately
  setGexUsers((prevUsers) =>
    prevUsers.map((u) =>
      u.id_utilisateur_gexonline === user.id_utilisateur_gexonline
        ? { ...u, archive: updatedArchiveState }
        : u
    )
  );

  setFilteredUsers((prevUsers) =>
    prevUsers.map((u) =>
      u.id_utilisateur_gexonline === user.id_utilisateur_gexonline
        ? { ...u, archive: updatedArchiveState }
        : u
    )
  );

  // Send the update to the server
  instance
    .post(`/api/utilisateurs/update/utilisateur/${user.id_utilisateur_gexonline}`, {
      ...user,
      archive: updatedArchiveState, // Persist the updated archive state
    })
    .then((response) => {
      
      // Ensure the local state matches the backend response
      const updatedUser = response.data;

      setGexUsers((prevUsers) =>
        prevUsers.map((u) =>
          u.id_utilisateur_gexonline === updatedUser.id_utilisateur_gexonline
            ? updatedUser
            : u
        )
      );

      setFilteredUsers((prevUsers) =>
        prevUsers.map((u) =>
          u.id_utilisateur_gexonline === updatedUser.id_utilisateur_gexonline
            ? updatedUser
            : u
        )
      );

      toast.current.show({
        severity: "success",
        summary: updatedArchiveState ? "Utilisateur archivé" : "Utilisateur désarchivé",
        detail: "Action réussie",
        life: 3000,
      });
    
    })
    .catch((error) => {
      console.error("Erreur lors de l'archivage :", error);

      // Rollback the optimistic update if there's an error
      setGexUsers((prevUsers) =>
        prevUsers.map((u) =>
          u.id_utilisateur_gexonline === user.id_utilisateur_gexonline
            ? { ...u, archive: !updatedArchiveState }
            : u
        )
      );

      setFilteredUsers((prevUsers) =>
        prevUsers.map((u) =>
          u.id_utilisateur_gexonline === user.id_utilisateur_gexonline
            ? { ...u, archive: !updatedArchiveState }
            : u
        )
      );

      toast.current.show({
        severity: "error",
        summary: "Erreur",
        detail: "Erreur lors de l'archivage",
        life: 3000,
      });
    });
};


  const confirmDeleteUser = (user) => {
    setSelectedUser(user);
    setDeleteDialog(true);
  };
  const deleteClient = () => {
    const utilisateurId = selectedUser.id_utilisateur_gexonline;
    DeleteUserByContact(utilisateurId, setSelectedUser)
        .then(() => {
            // Remove the deleted user from the state
            setGexUsers((prevUsers) =>
                prevUsers.filter((user) => user.id_utilisateur_gexonline !== utilisateurId)
            );
            setFilteredUsers((prevUsers) =>
                prevUsers.filter((user) => user.id_utilisateur_gexonline !== utilisateurId)
            );
            setDeleteDialog(false);
            toast.current.show({
                severity: "success",
                summary: "Réussi",
                detail: "Utilisateur supprimé",
                life: 3000,
            });
        })
        .catch((error) => {
            console.error("Erreur lors de la suppression :", error);
            toast.current.show({
                severity: "error",
                summary: "Erreur",
                detail: "Échec de la suppression de l'utilisateur",
                life: 3000,
            });
          });
        };
  
  const deleteDialogFooter = (
    <React.Fragment>
      <Button label="Non" icon="pi pi-times" className="p-button-text" onClick={() => setDeleteDialog(false)} />
      <Button label="Oui" icon="pi pi-check" className="p-button-text" onClick={deleteClient} />
    </React.Fragment>
  );
  
  
  const editUser = (user) => {
    setGexUser(user);
    setEditUserDialog(true);
  };
  const actionBodyTemplate = (rowData) => {
    return (
      <React.Fragment>
        <Button
          icon="pi pi-pencil"
          className="p-button-rounded succesBtn mr-2"
          onClick={() => editUser(rowData)}
        />
        <Button
        icon="pi pi-trash"
        className="p-button-rounded succesBtn"
        onClick={() => confirmDeleteUser(rowData)}
      />
    <span style={{ marginRight: '8px' }}></span>  {/* Spacer between the archive button and others */}
<Button
  icon={rowData.archive ? "pi pi-folder-open" : "pi pi-folder"}  // Open folder: Unarchive, Closed folder: Archive
  //className="p-button-rounded succesBtn"  // Matches the style of the other buttons
  className={`p-button-rounded ${rowData.archive ? 'p-button-danger' : 'p-button-success'}`}  // Red if archived, Green if unarchived
  onClick={() => handleArchiveUser(rowData)}
  tooltip={rowData.archive ? "Désarchiver" : "Archiver"}  // Tooltip shows appropriate action
  tooltipOptions={{ position: 'top' }}
/>


      
      </React.Fragment>
    );
  };
  const addUserDialogFooter = (
    <React.Fragment>
      <Button label="Annuler" icon="pi pi-times" className="p-button-text" onClick={() => setAddUserDialog(false)} />
      <Button label="Enregistrer" icon="pi pi-check" className="p-button-text" onClick={handleAddUser} />
    </React.Fragment>
  );

  const date_enrgistrement=(rowData)=> {
   
    const date= rowData.date_finalisation_enregistrement
     if (date)
        return moment(date).format("DD/MM/YYYY")
      else return ""
  }
  // Formatting the `lastseenconnexion` date
  const password_changed=(rowData)=> {
   
    const date= rowData.date_password_changed
     if (date)
        return moment(date).format("DD/MM/YYYY")
      else return ""
  }
  const lastSeenConnexion = (rowData) => {
    const date = rowData?.ladate_de_derniere_connexion; // Safely access the field
    console.log(date)
    return date ? moment(date).format("DD/MM/YYYY HH:mm") : "";
    
  };
  const firstseenConnexion = (rowData) => {
    const date = rowData?.firstSeenConnexion; // Safely access the field
    console.log(date)
    return date ? moment(date).format("DD/MM/YYYY HH:mm") : "";
    
  };
  
  const handleSearchChange = (e) => {
    const value = e.target.value;
    setSearchText(value); // Mettre à jour le texte de recherche
  
    if (value.trim() === "") {
      setFilteredUsers(GexUsers); // If the search field is empty, show all users
    } else {
      const filtered = GexUsers.filter(user => {
        // Format `ladate_de_derniere_connexion`
      // Format `ladate_de_derniere_connexion`
      const formattedConnexionDate = user.ladate_de_derniere_connexion
        ? moment(user.ladate_de_derniere_connexion).format("DD/MM/YYYY HH:mm")
        : "";

      // Format `date_de_finalisation_enregistrement`
      const formattedEnregistrementDate = user.date_de_finalisation_enregistrement
        ? moment(user.date_de_finalisation_enregistrement).format("DD/MM/YYYY HH:mm")
        : "";
        // Log dates for debugging
      console.log("Formatted Connexion Date:", formattedConnexionDate);
      console.log("Formatted Enregistrement Date:", formattedEnregistrementDate);
  
        // Perform case-insensitive search for strings, ID comparison, and check if dates match
        return (
          user.nom.toLowerCase().includes(value) ||
          user.prenom.toLowerCase().includes(value) ||
          user.email.toLowerCase().includes(value) ||
          (user.id_utilisateur_gexonline && user.id_utilisateur_gexonline.toString().includes(value)) ||
          (user.id_utilisateur_gexpertise && user.id_utilisateur_gexpertise.toString().includes(value)) ||
          formattedConnexionDate.toLowerCase().includes(value) || // Match against formatted `ladate_de_derniere_connexion`
          formattedEnregistrementDate.toLowerCase().includes(value) // Match against formatted `date_de_finalisation_enregistrement`
        );
      });
      setFilteredUsers(filtered); // Update the filtered user list
    }
  };

  const isFormFieldValid = (meta) => !!(meta.touched && meta.error);
  // const getFormErrorMessage = (meta) => {
  //   return (
  //     isFormFieldValid(meta) && <small className="p-error">{meta.error}</small>
  //   );
  // };
  const handleClientChange = (e) => {
    const selectedClientId = e.value;
  console.log("Dropdown value:", e.value); // Debugging
  if (!selectedClientId) {
    // Si aucune société n'est sélectionnée, réinitialiser l'état
    setUser({ ...user, rattache: null });
  }else{
  const selectedClient = clients.find(
    client => client.id_client_gexpertise.toString() === selectedClientId
  );
  console.log("Selected Client:", selectedClient); // Verify it’s not undefined

  if (selectedClient) {
    setUser({ ...user, rattache: selectedClient });
  }}
};
const resetUserForm = () => {
  setUser({
      nom: "",
      prenom: "",
      email: "",
      rattache: null,
      
  });
    setSelectedRole(null); // Reset roles to null
  setErrors({});
};
  const header = (
    <div className="table-header">
      <h5 className="mx-0 my-1">Liste des utilisateurs </h5>
      <span className="p-input-icon-right">
        <InputText
          type="search"
          value={searchText} // Affiche le texte de recherche actuel
          onChange={handleSearchChange} // Recherche à chaque modification
          placeholder=" Chercher..."
        />
        <i className="pi pi-search" />
      </span>
      <Button
          label="Créer"
          icon="pi pi-plus"
          className="addBtn succesBtn"
          style={{ color: '#fff', backgroundColor: '#970121' }}
          onClick={() => {
            resetUserForm()
            setAddUserDialog(true)}}
        />
    </div>
  );
  const secteurTab = Object.entries(secteurs).map((item) => {
    const [key, value] = item;
    return {
      name: value.libelle,
      value: value.id_secteur_activite_gexpertise,
     
    };
  });
  
const fonctionTab = Object.entries(fonctions).map((item) => {
  const [ key,value] = item;
  return {
    name: value.libelle,
    value: value.id_type_fonction_gexpertise,
   
  };
});



  const validate = (data) => {
    let errors = {};


    if (!data.nom) {
      errors.nom = "nom requis.";
    }
    if (!data.prenom) {
      errors.prenom = "prenom requis.";
    }
    if (!data.email) {
      errors.email = "adresse mail requis.";
    }
    if (!data.id_utilisateur_gexonline) {
      errors.id_utilisateur_gexonline = "l'identifiant est requis.";
    }
  }
  const OnSubmit = async (data) => {
    try {
      // Vérification des données avant traitement
      console.log("Données brutes avant traitement :", data);
      const bcryptRegex = /^\$2[aby]\$.{56}$/;
    if (data.password && !bcryptRegex.test(data.password)) {
  
      
        const saltRounds = 12; // Consistent with backend settings
        try {
          data.password = await bcrypt.hash(data.password, saltRounds);
        } catch (hashError) {
          console.error("Erreur lors du hachage du mot de passe :", hashError);
          throw new Error("Impossible de hacher le mot de passe.");
        }
      }else {
        console.log("Le mot de passe est déjà haché, aucun traitement supplémentaire nécessaire.");
      }
      // Format dates before sending to the API
    const payload = {
      ...data,
      date_password_changed: data.date_password_changed
        ? moment(data.date_password_changed).format("YYYY-MM-DDTHH:mm:ss")
        : null,
    };
  
      const id = data.id_utilisateur_gexonline;
      // Optimistic update
 
  
      console.log("Payload avant envoi :", data);
  
      const response = await instance.post(
        `/api/utilisateurs/update/utilisateur/${id}`,
        {
          id_utilisateur_gexpertise: data.id_utilisateur_gexpertise || "",
          id_utilisateur_gexonline: id || "",
          nom: data.nom || "",
          prenom: data.prenom || "",
          email: data.email || "",
          password: data.password || "",
          token_odoo: data.token_odoo || "",
          civilite: data.civilite || "",
          tel_mobile: data.tel_mobile || "",
          tel_fixe: data.tel_fixe || "",
          entreprise: data.entreprise || "",
          intitule_poste: data.intitule_poste || "",
          id_type_fonction: data.id_type_fonction || "",
          id_secteur_activite: data.id_secteur_activite || "",
          preference_vue: data.preference_vue || "",
          is_gex_memeber: data.is_gex_memeber || false,

        },
        {
          headers: { 'Content-Type': 'application/json' },
        }
      );
  
      console.log("Réponse de l'API :", response.data);
  
      const updatedUser = response.data;
      setGexUsers((prevUsers) =>
        prevUsers.map((u) =>
          u.id_utilisateur_gexonline === updatedUser.id_utilisateur_gexonline
            ? updatedUser
            : u
        )
      );
      setFilteredUsers((prevUsers) =>
        prevUsers.map((u) =>
          u.id_utilisateur_gexonline === updatedUser.id_utilisateur_gexonline
            ? updatedUser
            : u
        )
      );
      toast.current.show({
        severity: 'success',
        summary: 'Modification réussie',
        detail: 'Utilisateur bien modifié',
        life: 3000,
      });
      setEditUserDialog(false);

   


    } catch (error) {
      console.error("Erreur lors de la mise à jour :", error);
      toast.current.show({
        severity: 'error',
        summary: 'Erreur',
        detail: 'Échec de la mise à jour de l’utilisateur',
        life: 3000,
      });
    }
  };
  return (
    <div className="datatable-crud">
      <Toast ref={toast} />

      <DataTable
        ref={dt}
        value={currentData}
        dataKey="id"
        emptyMessage="Utilisateur introuvable"

        globalFilter={globalFilter}
        header={header}
        className="crudTable"
        scrollable
        scrollHeight="500px"
      >
        
        <Column
          field="id_utilisateur_gexonline"
          header="ID gexonline"
          style={{ maxWidth: "5rem" }}
          body={(rowData) => (
            <div className="table-data">
            <span className="mobile-header">ID gexonline </span>{rowData.id_utilisateur_gexonline}
            </div>
          )}
        ></Column>
        <Column
          field="id_utilisateur_gexpertise"
          header="ID Odoo"
          style={{ maxWidth: "10rem" }}
          body={(rowData) => (
            <div className="table-data">
            <span className="mobile-header">ID Odoo </span>{rowData.id_utilisateur_gexpertise}
            </div>
          )}
        ></Column>
        <Column
          field="prenom"
          header="Prénom"
          style={{ maxWidth: "8rem" }}
          body={(rowData) => (
            <div className="table-data">
            <span className="mobile-header">Prénom </span>{rowData.prenom}
            </div>
          )}
        ></Column>
        <Column field="nom" header="Nom" style={{ maxWidth: "8rem" }}
        body={(rowData) => (
          <div className="table-data">
          <span className="mobile-header">Nom </span>{rowData.nom}
          </div>
        )}></Column>
        
        <Column
          field="email"
          header="Email"
          style={{ maxWidth: "35rem", minWidth: "20rem" }}
          body={(rowData) => (
            <div className="table-data">
            <span className="mobile-header">Email </span>{rowData.email}
            </div>
          )}
        ></Column>
        
        <Column 
        
       
        header ="Date de finalisation d'enregistrement" 
        style={{ minWidth: "15rem" }}
        body={(rowData) => (
          <div className="table-data">
            <span className="mobile-header">Date de finalisation d'enregistrement </span>
            {date_enrgistrement(rowData)}
          </div>
        )}>
      </Column>
      <Column 
       header ="La date de changement de mot de passe" 
       style={{ minWidth: "15rem" }}
       body={(rowData) => (
        <div className="table-data">
          <span className="mobile-header">La date de changement de mot de passe </span>
          {password_changed(rowData)}
        </div>
      )}
       >
     </Column>
    
       <Column 
       header ="La dernière connexion" 
       style={{ minWidth: "15rem" }}
       body={(rowData) => (
        <div className="table-data">
          <span className="mobile-header">La dernière connexion </span>
          {lastSeenConnexion(rowData)}
        
        </div>
      )}
       >
     </Column> 
     <Column
  field="firstseenconnexion"
  header="FirstSeen"
  body={(rowData) => {
    const date = rowData.firstseenconnexion ? new Date(rowData.firstseenconnexion) : null;
    return (
      <div className="table-data">
        <span className="mobile-header">FirstSeen </span>
        {date ? date.toLocaleDateString("fr-FR") :""}
      </div>
    );
  }}
></Column>


        

        <Column
          body={actionBodyTemplate}
          exportable={false}
          header="Actions"
          style={{ minWidth: "8rem" }}
        ></Column>
      </DataTable>
      
      <Pagination
        currentPage={currentPage}
        totalPages={totalPages}
        dataPerPage={dataPerPage}
        setDataPerPage={setDataPerPage}
        handlePageChange={handlePageChange}
      />
      <Dialog
        visible={addUserDialog}
        style={{ width: "450px" }}
        header="Ajouter un utilisateur"
        modal
        className="p-fluid"
        footer={addUserDialogFooter}
        onHide={() => setAddUserDialog(false)
        }
      >
        
        <div className="field">
          <label htmlFor="nom">Nom</label>
          <InputText id="nom" value={user.nom} onChange={(e) => setUser({ ...user, nom: e.target.value })} 
          className={errors.nom ? 'input-error' : ''} />
          {errors.nom && <span className="error-message">{errors.nom}</span>}
        </div>

        <div className="field">
          <label htmlFor="prenom">Prénom</label>
          <InputText id="prenom" value={user.prenom} onChange={(e) => setUser({ ...user, prenom: e.target.value })} 
          className={errors.prenom ? 'input-error' : ''} />
          {errors.prenom && <span className="error-message">{errors.prenom}</span>}
        </div>

        <div className="field1">
          <label htmlFor="email">Email</label>
          <InputText id="email" value={user.email} onChange={(e) => setUser({ ...user, email: e.target.value })} 
          className={errors.email ? 'input-error' : ''} 
           />
          {errors.email && <span className="error-message">{errors.email}</span>}
        </div>
        <div className="field" style={{marginTop:"15px"}}>
  <label htmlFor="role">Rôle</label>
  <Dropdown
    id="role"
    value={selectedRole}
    options={roles}
    onChange={(e) => setSelectedRole(e.value)}
    placeholder="Sélectionnez un rôle"
    className={errors.role ? "input-error" : ""}
  />
  {errors.role && <span className="error-message">{errors.role}</span>}
</div>


        <div className="field">
          <label htmlFor="client">Rattaché à</label>
          <Dropdown
  id="client"
  value={user.rattache ? user.rattache.id_client_gexpertise : null}
  options={clients.map((client) => ({
    label: `${client.nom} (id: ${client.id_client_gexpertise})`,
    value: client.id_client_gexpertise.toString(),
  }))}
  onChange={(e) => handleClientChange(e)}
  placeholder="Sélectionnez une société"
  optionLabel="label"
  optionValue="value"
  filter
  className={errors.rattache ? "input-error" : ""}
  showClear // Permet de réinitialiser la sélection
/>


          
        </div>
      </Dialog>

      {GexUser && (
        
        <Dialog
          visible={editUserDialog}
          header="Détail d'un utilisateur"
          modal
          className="p-fluid UpdateUser"
          
          onHide={(e) => setEditUserDialog(false)}
        >
          
          <div>
            <Form
              onSubmit={OnSubmit}
              initialValues={{
                email: GexUser.email,
                password:GexUser.password ? GexUser.password : "",
                prenom: GexUser?.prenom ? GexUser?.prenom : "",
                nom: GexUser?.nom ? GexUser?.nom : "",
                entreprise: GexUser?.entreprise ? GexUser?.entreprise : "",
                tel_fixe: GexUser.tel_fixe ? GexUser.tel_fixe : "",
                tel_mobile: GexUser.tel_mobile ? GexUser.tel_mobile : "",
                intitule_poste: GexUser.intitule_poste
                  ? GexUser.intitule_poste
                  : "",
                id_secteur_activite: GexUser.id_secteur_activite ? GexUser.id_secteur_activite :"",
                id_type_fonction: GexUser.id_type_fonction ? GexUser.id_type_fonction :"",
                id_utilisateur_gexonline: GexUser.id_utilisateur_gexonline ? GexUser.id_utilisateur_gexonline :"",
                id_utilisateur_gexpertise: GexUser.id_utilisateur_gexpertise ? GexUser.id_utilisateur_gexpertise :"",
                token_odoo: GexUser.token_odoo ? GexUser.token_odoo :"",
                civilite: GexUser.civilite ? GexUser.civilite :"",
                preference_vue: GexUser.preference_vue ? GexUser.preference_vue :"",
                is_gex_memeber: GexUser.is_gex_memeber ? GexUser.is_gex_memeber : false

              }}
              validate={validate}
              render={({ handleSubmit }) => (
                <form onSubmit={handleSubmit} className="p-fluid ">
                <div className="p-fluid  updateField">
                  <div className="field col-md-4 col-sm-12">
                    <label htmlFor="id_utilisateur_gexonline">
                      id Gexonline
                    </label>
                    <Field
                      name="id_utilisateur_gexonline"
                      render={({ input, meta }) => (
                        <span className="p-float-label">
                          <InputText
                            id="id_utilisateur_gexonline"
                            // defaultValue={GexUser?.id_utilisateur_gexonline}

                            required
                            {...input}
                            readOnly
                            className={classNames({
                              "p-invalid": isFormFieldValid(meta),
                            })}
                          />
                          <label
                            htmlFor="id_utilisateur_gexonline"
                            className={classNames({
                              "p-error": isFormFieldValid(meta),
                            })}
                          ></label>
                        </span>
                      )}
                    />
                  </div>
                  <div className="field col-md-4 col-sm-12">
                  <label htmlFor="id_utilisateur_gexpertise">ID Odoo</label>
                    <Field
                      name="id_utilisateur_gexpertise"
                      render={({ input, meta }) => (
                        <span className="p-float-label">
                          <InputText
                            id="id_utilisateur_gexpertise"
                            {...input}
                            className={classNames({
                              "p-invalid": isFormFieldValid(meta),
                            })}
                          />
                      
                        </span>
                      )}
                    />
                  </div>
                  <div className="field col-md-4 col-sm-12">
                    <label htmlFor="nom">Nom</label>
                    <Field
                      name="nom"
                      render={({ input, meta }) => (
                        <span className="p-float-label ">
                          <InputText
                            id="nom"
                            {...input}
                            className={classNames({
                              "p-invalid": isFormFieldValid(meta),
                            })}
                          />
                          <label
                            htmlFor="nom"
                            className={classNames({
                              "p-error": isFormFieldValid(meta),
                            })}
                          ></label>
                        </span>
                      )}
                    />
                  </div>
                  </div>
                  <div className="p-fluid  updateField">
                  <div className="field col-md-4 col-sm-12">
                    <label htmlFor="prenom">Prenom</label>
                    <Field
                      name="prenom"
                      render={({ input, meta }) => (
                        <span className="p-float-label ">
                          <InputText
                            id="prenom"
                            {...input}
                            className={classNames({
                              "p-invalid": isFormFieldValid(meta),
                            })}
                          />
                          <label
                            htmlFor="prenom"
                            className={classNames({
                              "p-error": isFormFieldValid(meta),
                            })}
                          ></label>
                        </span>
                      )}
                    />
                  </div>
                  <div className="field col-md-4 col-sm-12">
                    <label htmlFor="email">Email</label>
                    <Field
                      name="email"
                      render={({ input, meta }) => (
                        <span className="p-float-label ">
                          <InputText
                            id="email"
                            {...input}
                            className={classNames({
                              "p-invalid": isFormFieldValid(meta),
                            })}
                          />
                          <label
                            htmlFor="email"
                            className={classNames({
                              "p-error": isFormFieldValid(meta),
                            })}
                          ></label>
                        </span>
                      )}
                      />
                  </div>
                  <div className="field col-md-4 col-sm-12">
                    <label htmlFor="password">Mot de passe</label>
                    <Field
                      name="password"
                      render={({ input, meta }) => (
                        <span className="p-float-label ">
                          <InputText
                            id="password"
                            {...input}
                            className={classNames({
                              "p-invalid": isFormFieldValid(meta),
                            })}
                          />
                          <label
                            htmlFor="password"
                            className={classNames({
                              "p-error": isFormFieldValid(meta),
                            })}
                          ></label>
                        </span>
                      )}
                    />
                  </div>
                  </div>
                  <div className="p-fluid  updateField">
                  <div className="field col-md-4 col-sm-12">
                    <label htmlFor="entreprise">Entreprise</label>
                    <Field
                      name="entreprise"
                      render={({ input, meta }) => (
                        <span className="p-float-label ">
                          <InputText
                            id="entreprise"
                            {...input}
                            className={classNames({
                              "p-invalid": isFormFieldValid(meta),
                            })}
                          />
                          <label
                            htmlFor="entreprise"
                            className={classNames({
                              "p-error": isFormFieldValid(meta),
                            })}
                          ></label>
                        </span>
                      )}
                    />
                  </div>
                  <div className="field col-md-4 col-sm-12">
                    <label htmlFor="token_odoo">Token Odoo</label>
                    <Field
                      name="token_odoo"
                      render={({ input, meta }) => (
                        <span className="p-float-label ">
                          <InputText
                            id="token_odoo"
                            {...input}
                            className={classNames({
                              "p-invalid": isFormFieldValid(meta),
                            })}
                          />
                          <label
                            htmlFor="token_odoo"
                            className={classNames({
                              "p-error": isFormFieldValid(meta),
                            })}
                          ></label>
                        </span>
                      )}
                    />
                  </div>
                  <div className="field col-md-4 col-sm-12">
                    <label htmlFor="civilite">Civilité</label>
                    <Field
                      name="civilite"
                      render={({ input, meta }) => (
                        <span className="p-float-label ">
                          <Dropdown
                              id="civilite" 
                              
                              options={['Monsieur', 'Madame']}
                                                           
                              {...input}
                              className={classNames({
                                "p-invalid": isFormFieldValid(meta),
                              })}
                            />
                          <label
                            htmlFor="civilite"
                            className={classNames({
                              "p-error": isFormFieldValid(meta),
                            })}
                          ></label>
                        </span>
                      )}
                    />
                  </div>
                  </div>
                  <div className="p-fluid  updateField">
                  <div className="field col-md-4 col-sm-12">
                    <label htmlFor="tel_mobile">Mobile </label>
                    <Field
                      name="tel_mobile"
                      render={({ input, meta }) => (
                        <span className="p-float-label ">
                          <InputText
                            id="tel_mobile"
                            {...input}
                            className={classNames({
                              "p-invalid": isFormFieldValid(meta),
                            })}
                          />
                          <label
                            htmlFor="tel_mobile"
                            className={classNames({
                              "p-error": isFormFieldValid(meta),
                            })}
                          ></label>
                        </span>
                      )}
                    />
                  </div>
                  <div className="field col-md-4 col-sm-12">
                    <label htmlFor="tel_fixe">Tel Fixe </label>
                    <Field
                      name="tel_fixe"
                      render={({ input, meta }) => (
                        <span className="p-float-label ">
                          <InputText
                            id="tel_fixe"
                            {...input}
                            className={classNames({
                              "p-invalid": isFormFieldValid(meta),
                            })}
                          />
                          <label
                            htmlFor="tel_fixe"
                            className={classNames({
                              "p-error": isFormFieldValid(meta),
                            })}
                          ></label>
                        </span>
                      )}
                    />
                  </div>
                  <div className="field col-md-4 col-sm-12">
                    <label htmlFor="intitule_poste">Intitulé Poste </label>
                    <Field
                      name="intitule_poste"
                      render={({ input, meta }) => (
                        <span className="p-float-label ">
                          <InputText
                            id="intitule_poste"
                            {...input}
                            className={classNames({
                              "p-invalid": isFormFieldValid(meta),
                            })}
                          />
                          <label
                            htmlFor="intitule_poste"
                            className={classNames({
                              "p-error": isFormFieldValid(meta),
                            })}
                          ></label>
                        </span>
                      )}
                    />
                  </div>
                  </div>
                  <div className="p-fluid  updateField">
                  <div className="field col-md-4 col-sm-12">
                    <label htmlFor="id_type_fonction">Type de fonction </label>
                    <Field
                      name="id_type_fonction"
                      render={({ input, meta }) => (
                        <span className="p-float-label ">
                          <Dropdown
                              id="type_fonction" 
                              options={fonctionTab}
                              optionLabel="name" 
                              
                              {...input}
                              className={classNames({
                                "p-invalid": isFormFieldValid(meta),
                              })}
                            />
                          <label
                            htmlFor="id_type_fonction"
                            className={classNames({
                              "p-error": isFormFieldValid(meta),
                            })}
                          ></label>
                        </span>
                      )}
                    />
                  </div>
                  <div className="field col-md-4 col-sm-12">
                    <label htmlFor="id_secteur_activite">
                      Secteur d'activité{" "}
                    </label>
                    <Field
                      name="id_secteur_activite"
                      render={({ input, meta }) => (
                        <span className="p-float-label ">
                        <Dropdown
                              id="secteur_activite" 
                              
                              options={secteurTab}
                              optionLabel="name" 
                              
                              {...input}
                              className={classNames({
                                "p-invalid": isFormFieldValid(meta),
                              })}
                            />
                          <label
                            htmlFor="id_secteur_activite"
                            className={classNames({
                              "p-error": isFormFieldValid(meta),
                            })}
                          ></label>
                        </span>
                      )}
                    />
                  </div>
                  <div className="field col-md-4 col-sm-12">
                    <label htmlFor="preference_vue">preference Vue </label>
                    <Field
                      name="preference_vue"
                      render={({ input, meta }) => (
                        <span className="p-float-label ">
                          <Dropdown
                            id="preference_vue" 
                            options={['Vue cartographie', 'Vue Liste']}
                            {...input}
                            className={classNames({
                              "p-invalid": isFormFieldValid(meta),
                            })}
                          />
                          <label
                            htmlFor="preference_vue"
                            className={classNames({
                              "p-error": isFormFieldValid(meta),
                            })}
                          ></label>
                        </span>
                      )}
                    />
                   
                  </div>
                  </div>
                  <div className="p-fluid updateField">
                  <div className="field col-md-4 col-sm-12">
                  <Field name="is_gex_memeber" type="checkbox" 
                       >
                            {({ input, meta }) => (
                                <div style={{display:"flex", flexDirection:"row"}}>
                               
                                    <input {...input} id="is_gex_memeber"   
                                    // hidden={selectedClient !=="1"}

                                    />
                                    <label htmlFor="is_gex_memeber" 
                                    //  hidden={selectedClient !=="1"}
                                     >
                                    membre de Gexpertise
                                    </label>
                                  
                                </div>
                            )}
                        </Field>
                        <label htmlFor="binary"> </label>
                    <label htmlFor="binary"> </label>
                  </div>
                  </div>
                  
                  <div className="btn-regiqter col-md-12 col-sm-12">
                    <Button
                      type="submit"
                      label="Enregistrer"
                      className="p-mt-2 enregistrer"
                    />
                    </div>
                </form>
              )}
            />
          </div>
        </Dialog>
      )}
      {/* Delete Confirmation Dialog */}
<Dialog
  visible={deleteDialog}
  style={{ width: "450px" }}
  header="Confirmer la suppression"
  modal
  footer={deleteDialogFooter}
  onHide={() => setDeleteDialog(false)}
>
  <div className="confirmation-content">
    <i className="pi pi-exclamation-triangle" style={{ fontSize: '2rem' }} />
    {selectedUser && (
      <span>
        Êtes-vous sûr de vouloir supprimer <b>{selectedUser.nom}</b>?
      </span>
    )}
  </div>
</Dialog>
      
     
    </div>
    
  );
}
